import Symbol from "./Symbol";
import { INSPECTOR_THREE_WINDING_TRANSFORMER } from "../../../constants/inspectorConstants";

class ThreeWindingTransformer extends Symbol {
    constructor({ alias, svgSrc, label, rotable, handles, name}) {
        super("ThreeWindingTransformer", { alias, svgSrc, label, rotable, handles, name });

        this.attributes = {
            ...this.attributes,
            brand: { isVisible: false, value: null, label: "Marca" },
            model: { isVisible: false, value: null, label: "Modelo" },
            type: { isVisible: false, value: null, label: "Tipo" },
            ratedPower: { isVisible: false, value: null, label: "Potencia Nominal" },
            coolingType: { isVisible: false, value: null, label: "Tipo de Enfriamiento" },
            impedance: { isVisible: false, value: null, label: "Impedancia" },
            neutralImpedance: { isVisible: false, value: null, label: "Impedancia de Neutro (ZN)" },
            taps: { isVisible: false, value: null, label: "Taps" },
            PrimaryVoltage: { isVisible: false, value: null, label: "Voltaje Primario" },
            SecondaryVoltage: { isVisible: false, value: null, label: "Voltaje Secundario" },
            TertiaryVoltage: { isVisible: false, value: null, label: "Voltaje Terciario" },
            PrimaryConnection: { isVisible: false, value: null, label: "Conexión Primaria" },
            SecondaryConnection: { isVisible: false, value: null, label: "Conexión Secundaria" },
            TertiaryConnection: { isVisible: false, value: null, label: "Conexión Terciaria" },
        };                
    }

    getInspector() {
        return INSPECTOR_THREE_WINDING_TRANSFORMER;
    }
}

export default ThreeWindingTransformer;
